import Column from '@components/column'
import { FC } from 'react'
import CardHeading from '@commons/headings/card'
import { Formik, Form } from 'formik'
import Fields from '@components/fields'
interface AppointmentDescriptionProps {
  description: string
}
const AppointmentDescription: FC<AppointmentDescriptionProps> = ({
  description,
}) => {
  return (
    <Column
      bg="white"
      styleColumn="padding:20px;border-radius:12px;"
      rowGap={15}
    >
      <CardHeading title="Patient Notes" tc="primary" />
      <Formik
        initialValues={{
          description: description,
        }}
        onSubmit={() => {}}
      >
        {() => {
          return (
            <Form>
              <Fields.TextArea
                name="description"
                placeholder="Any Additional Information you want to share.."
                disabled
              />
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default AppointmentDescription
